/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2v1.9h1V4h.9v-.1H4V3h-.1V2zm5.5 0H5.7v2h1.8zm3.6 0H9.3v2h1.8zm3.6 0h-1.8v2h1.8zm3.6 0h-1.8v2h1.8zm1.8 0v1H20v.9h.1V4h.9v-.1h1V2zM22 7.5V5.7h-2v1.8zM2 5.7v1.8h2V5.7zm20 5.4V9.3h-2v1.8zM2 9.3v1.8h2V9.3zm20 5.4v-1.8h-2v1.8zM2 12.9v1.8h2v-1.8zm20 5.4v-1.8h-2v1.8zM2 16.5v1.8h2v-1.8zM3.9 22v-1H4v-.9h-.1V20H3v.1H2V22zm1.8 0h1.8v-2H5.7zm3.6 0h1.8v-2H9.3zm3.6 0h1.8v-2h-1.8zm3.6 0h1.8v-2h-1.8zm3.6 0H22v-1.9h-1V20h-.9v.1H20v.9h.1zM7 7h4v4H7zm6 0h4v4h-4zm4 6h-4v4h4zM7 13h4v4H7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGroup as Group };
